<script lang="ts">
    import { originURL } from "../../../../api/hooks/config-client"
    import { getCachedEntry } from "../../api"
    import NotFound from "../../routes/NotFound.svelte"
    import Breadcrumbs from "./Breadcrumbs.svelte"
    import ContentBlock from "./ContentBlock.svelte"
    import NewsTitle from "./NewsTitle.svelte"

    export let location: LocationStore = undefined
    export let id: string = undefined
    export let allwaysInView: boolean = false

    export let previewContent: ContentEntry = undefined

    let loading = true
    let contentEntry: ContentEntry
    async function loadContent() {
        loading = true
        contentEntry = null
        try {
            contentEntry = await getCachedEntry(
                "content",
                location ? { $or: [{ path: location.path }, { "alternativePaths.path": location.path }] } : { _id: id }
            )
        } catch (e) {
            console.error(e)
        }
        loading = false
    }

    // only load new content if location.path or id changes
    let _location: typeof location
    let _id: typeof id
    $: if (previewContent) {
        contentEntry = previewContent
        loading = false
    } else if (location?.path != _location?.path || id != _id) {
        _id = id
        _location = location
        loadContent()
    }

    $: breadCrumbPosition = contentEntry?.blocks?.length && contentEntry.blocks[0].type?.startsWith("hero") ? 1 : 0
</script>

<svelte:head>
    {#if contentEntry}
        {#if contentEntry.meta?.title || contentEntry.name}
            <title>SPORTident - {contentEntry.meta?.title || contentEntry.name}</title>
        {/if}
        {#if contentEntry.meta?.description}
            <meta name="description" content="{contentEntry.meta.description}" />
        {/if}
        {#if contentEntry.meta?.keywords}
            <meta name="keywords" content="{contentEntry.meta.keywords}" />
        {/if}
        <!-- if not active do not index -->
        {#if !contentEntry.active}
            <meta name="robots" content="noindex" />
        {/if}

        {#if contentEntry.path && location?.path != contentEntry.path}
            <link rel="canonical" href="{originURL}{contentEntry.path}" />
        {/if}
    {/if}
</svelte:head>

{#if loading}
    .... lade
{:else if contentEntry}
    {#each contentEntry.blocks as block, idx}
        {#if idx === breadCrumbPosition}
            <Breadcrumbs {location} />
            {#if contentEntry.type == "news"}
                <NewsTitle {contentEntry} />
            {/if}
        {/if}
        <ContentBlock {block} {allwaysInView} />
    {/each}
{:else}
    <NotFound />
{/if}
